export default __webpack_public_path__ + "static/media/logo.fab7d4c5.svg";